module.exports = __webpack_public_path__ + "static/assets/b2c44c738c9cbc1a99cd6edfd0c2b85b.svg";